import styles from "./MypageInput.module.scss";
import { useState } from "react";
import { validateRequired, validateMaxlength } from "../../utils/validate";

const MypageTextField = ({
  type = "text",
  name,
  label,
  subLabel = false,
  maxLength = null,
  register,
  validation = {},
  errors,
  watch,
  required = false,
  placeholder = "",
  autocomplete = null,
  isStatic = false,
  readOnly = false,
}) => {
  /**** type="password"のときに使用 ****/
  const [isRevealPassword, setIsRevealPassword] = useState(false);

  const togglePassword = () => {
    setIsRevealPassword((prevState) => !prevState);
  };

  const returnText = () => {
    const value = watch(name);
    return typeof value !== "undefined" &&
      value !== null &&
      value.length > 0 ? (
      value
    ) : (
      <p>&emsp;</p>
    );
  };

  /**** バリデーションルール設定 ****/
  // 項目ごとのルール
  let txt_validation = validation;
  if (maxLength) {
    // 最大文字数が設定されていたら最大文字数バリデーションルール設定
    txt_validation = { ...txt_validation, ...validateMaxlength(maxLength) };
  }
  if (required) {
    // 必須項目なら必須バリデーションルール設定
    txt_validation = { ...txt_validation, ...validateRequired() };
  }

  return (
    <div className={styles.mypageform__block}>
      <div className={`${styles.mypageform__ttl} ${subLabel ? "fs-4" : ""}`}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__field} ${isStatic ? "d-none" : ""}`}
      >
        <input
          type={
            type === "password"
              ? isRevealPassword
                ? "text"
                : "password"
              : type
          }
          name={name}
          className={`${styles.mypageform__txt} form-control ${
            errors[name] ? "is-invalid" : ""
          }`}
          // maxLength={maxLength}
          placeholder={placeholder}
          autoComplete={autocomplete}
          {...register(name, txt_validation)}
          readOnly={readOnly}
        />
        <>
          {type === "password" ? (
            <input
              type="button"
              className={
                isRevealPassword
                  ? styles.mypagepassword__display02
                  : styles.mypagepassword__display01
              }
              value={isRevealPassword ? "非表示" : "表示"}
              onClick={() => togglePassword()}
            />
          ) : (
            <></>
          )}
        </>
        <>
          {errors[name] ? (
            <p className={`invalid-feedback ${styles.mypageform__msg}`}>
              {errors[name].message}
            </p>
          ) : (
            <></>
          )}
        </>
      </div>
      {/* 確認画面表示用 */}
      {isStatic && (
        <div className={`${styles.mypageform__label} ws-pre-wrap ps-4`}>
          {returnText()}
        </div>
      )}
    </div>
  );
};

export default MypageTextField;
